module.exports = __webpack_public_path__ + "img/formulaone.8c847817.svg";